<div class="row align-items-start mb-4">
    <div class="col-auto">
        <app-back-button></app-back-button>
    </div>
    <div class="col-auto mx-auto">
        <h5>{{ "PAGES.SELECT-CATEGORY" | translate }}</h5>
    </div>
    <div class="col-auto d-none d-lg-block" style="width: 120px"></div>
</div>
<div
    [nbSpinner]="loading"
    [style]="{
        'min-height': '200px'
    }"
    class="row"
>
    <div class="col-lg-6" *ngFor="let category of categories">
        <nb-card class="mb-0">
            <nb-card-body>
                <div class="d-flex">
                    <nb-radio-group [(ngModel)]="selectedCategory">
                        <nb-radio [value]="category">{{ category.descricao }}</nb-radio>
                    </nb-radio-group>
                </div>
                <div class="category-info-list">
                    <div class="category-info">
                        <p>{{ category.qtd_confirmada }} {{ "GENERAL.SUBSCRIBERS" | translate }}</p>
                        <nb-icon icon="people-outline"></nb-icon>
                    </div>
                    <div class="category-info" *ngIf="category.id_ficha">
                        <p>#{{ category.id_ficha }}</p>
                    </div>
                    <div class="category-info" *ngIf="category.dt_final_cancelamento">
                        <p>{{ "GENERAL.CANCEL-UNTIL" | translate }} {{ category.dt_final_cancelamento }}</p>
                    </div>
                </div>
            </nb-card-body>
        </nb-card>
    </div>
</div>

<div class="d-flex justify-content-center mt-3">
    <button nbButton status="danger" [disabled]="!selectedCategory || loading" (click)="onCancelEnrollment($event)">
        {{ "BUTTONS.CANCEL-SUBSCRIPTION" | translate }} <nb-icon icon="arrow-forward-outline"></nb-icon>
    </button>
</div>
